import TaiXiu from "./components/tai-xiu/TaiXiu";
import HiLo from "./components/hi-lo/HiLo";
import Domino from "./components/domino/Domino";
import MaxRacing from "./components/max-racing/MaxRacing";
import Fantan from "./components/fantan/Fantan";
import ThaiHilo from "./components/thai-hilo/ThaiHilo";
import SeDie from "./components/se-die/SeDie";
import "iview/dist/styles/iview.css";
import "./assets/styles/less/index.less";

const Max3D = {};

Max3D.install = function (Vue) {
  Vue.component("tai-xiu", TaiXiu),
  Vue.component("hi-lo", HiLo),
  Vue.component("domino", Domino);
  Vue.component("max-racing", MaxRacing);
  Vue.component("fantan", Fantan);
  Vue.component("thai-hilo", ThaiHilo);
  Vue.component("se-die", SeDie);
};

export default Max3D;
